export default __webpack_public_path__ + "static/media/example.ab254440.gif";